import React from 'react';

import { SVGComponentProps } from './svg.types';

const TextBubbleSVG = ({
  size = '1em',
  stroke = '#6B7280',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M14.9833 8.99167V12.325C14.9833 12.5417 14.975 12.75 14.95 12.95C14.7583 15.2 13.4333 16.3167 10.9917 16.3167H10.6583C10.45 16.3167 10.25 16.4167 10.125 16.5833L9.12501 17.9167C8.68334 18.5083 7.96667 18.5083 7.525 17.9167L6.52499 16.5833C6.41666 16.4417 6.175 16.3167 5.99167 16.3167H5.65834C3.00001 16.3167 1.66667 15.6583 1.66667 12.325V8.99167C1.66667 6.55001 2.79167 5.22501 5.03334 5.03334C5.23334 5.00834 5.44167 5 5.65834 5H10.9917C13.65 5 14.9833 6.33334 14.9833 8.99167Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3167 5.65769V8.99102C18.3167 11.441 17.1917 12.7577 14.95 12.9494C14.975 12.7494 14.9833 12.541 14.9833 12.3244V8.99102C14.9833 6.33269 13.65 4.99935 10.9917 4.99935H5.65834C5.44167 4.99935 5.23334 5.00769 5.03334 5.03269C5.22501 2.79102 6.55001 1.66602 8.99167 1.66602H14.325C16.9833 1.66602 18.3167 2.99936 18.3167 5.65769Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2462 11.0417H11.2537"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.32958 11.0417H8.33708"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.41292 11.0417H5.42042"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default TextBubbleSVG;
